import { NgClass, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DsAbstractButtonComponent } from '@abstract/components/ds-abstract-button.component';

@Component({
  selector: 'ds-icon-button',
  templateUrl: './ds-icon-button.component.html',
  styleUrls: ['./ds-icon-button.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, RouterLink, MatIconModule, MatRippleModule, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsIconButtonComponent extends DsAbstractButtonComponent {
  /**
   * Returns a list of CSS classes for the button based on its current state.
   *
   * Classes are based on:
   * - button size
   * - button theme
   * - destructive or default appearance
   *
   */
  get buttonClasses(): string[] {
    return [
      'ds-icon-button--' + this.size,
      'ds-button--' + this.theme,
      this.isDestructive ? 'ds-button--destructive' : 'ds-button--default',
    ];
  }
}
